import React from 'react';
import { result, isArray } from 'underscore';
import { Selection } from '@fluentui/react';

function reducer(state, action) {
  const { type, payload } = action;

  switch (type) {
    case 'FINISH_LOAD_DATA': {
      if (state.items.length > 0) {
        const aggregatedItems = state.formatResponse(payload.response, state.aggregatedRowConfig);
        return {
          ...state,
          aggregatedItems,
          isAggregatedItemsVisible: true,
          items: [...state.items, ...aggregatedItems],
        };
      }
      return state;
    }
    case 'SHOW_AGGREGATED_ITEMS':
      if (state.isAggregatedItemsVisible) {
        return state;
      }
      return {
        ...state,
        isAggregatedItemsVisible: true,
        items: [...state.items, ...state.aggregatedItems],
      };
    case 'HIDE_AGGREGATED_ITEMS':
      if (!state.isAggregatedItemsVisible) {
        return state;
      }
      return {
        ...state,
        isAggregatedItemsVisible: false,
        items: state.items.filter(item => !item.isAggregatedRow),
      };
    default:
      return state;
  }
}

const columnProcessor = column => ({
  ...column,
  onRender: (item, ...args) => {
    if (item.isAggregatedRow) {
      if (column.onRenderAggregatedRow) {
        return column.onRenderAggregatedRow(item, ...args);
      }
      return (<span>-</span>);
    }
    return column.onRender(item, ...args);
  },
});

const getInitialState = props => ({
  aggregatedRowConfig: props.aggregatedRowConfig,
  aggregatedItems: [],
  isAggregatedItemsVisible: false,
  selection: new Selection({
    canSelectItem: item => (!item.isAggregatedRow),
  }),
  formatResponse: (response, aggregatedRowConfig) => (isArray(aggregatedRowConfig) ?
    aggregatedRowConfig.map(row => ({
      ...row,
      ...(result(response, row.dataKey, {})),
      ...(row.number ? { count: result(response, row.number, '') } : {}),
      isAggregatedRow: true,
      disableCheckbox: true,
    })) : []),
  columnProcessors: [...(result(props, 'columnProcessors', [])), columnProcessor],
});


export default {
  reducer,
  getInitialState,
};
